// extracted by mini-css-extract-plugin
export default {"field":"views__mobile-view__components__field__field","fieldsRow":"views__mobile-view__components__field__fieldsRow"};